<div #fieldBox
     class="xp-date-time__field"
     [class.xp-date-time__field--open]="open()"
     [class.xp-date-time__field--disabled]="disabled()">
	<input class="xp-date-time__input"
	       type="text"
	       readonly
	       aria-haspopup="dialog"
	       [attr.aria-label]="ariaLabel()"
	       [attr.aria-expanded]="open()"
	       [disabled]="disabled()"
	       [value]="text()"
	       (click)="openPanel()"
	       (focus)="openPanel()" />
	<button type="button"
	        class="xp-date-time__button"
	        aria-label="Choose a date and time"
	        [disabled]="disabled()"
	        (click)="togglePanel()">
		<mat-icon>calendar_today</mat-icon>
	</button>
</div>
<ng-container #panelOutlet></ng-container>
<ng-template #panelTemplate>
	<div class="xp-date-time__panel"
	     [class.xp-date-time__panel--disabled]="disabled()"
	     role="dialog"
	     [attr.aria-label]="ariaLabel() || 'Choose a date and time'">
		<mat-calendar #calendar
		              class="xp-date-time__month"
		              [headerComponent]="header"
		              [startAt]="value()"
		              [selected]="value()"
		              [maxDate]="max()"
		              (selectedChange)="onDateSelected($event)"></mat-calendar>
		<div class="xp-date-time__time">
			<div class="xp-date-time__column xp-date-time__column--hour">
				<button type="button"
				        class="xp-date-time__step"
				        aria-label="Next hour"
				        (pointerdown)="startStep('hour', 1, $event)"
				        (pointerup)="endStep()"
				        (pointerleave)="endStep()"
				        (pointercancel)="endStep()"
				        (keydown.enter)="stepByKey('hour', 1, $event)"
				        (keydown.space)="stepByKey('hour', 1, $event)"
				        (keyup.enter)="endStep()"
				        (keyup.space)="endStep()">
					<mat-icon>expand_less</mat-icon>
				</button>
				<span class="xp-date-time__number">{{ hourText() }}</span>
				<button type="button"
				        class="xp-date-time__step"
				        aria-label="Previous hour"
				        (pointerdown)="startStep('hour', -1, $event)"
				        (pointerup)="endStep()"
				        (pointerleave)="endStep()"
				        (pointercancel)="endStep()"
				        (keydown.enter)="stepByKey('hour', -1, $event)"
				        (keydown.space)="stepByKey('hour', -1, $event)"
				        (keyup.enter)="endStep()"
				        (keyup.space)="endStep()">
					<mat-icon>expand_more</mat-icon>
				</button>
			</div>
			<div class="xp-date-time__separator"><span class="xp-date-time__number">:</span></div>
			<div class="xp-date-time__column xp-date-time__column--minute">
				<button type="button"
				        class="xp-date-time__step"
				        aria-label="Next minute"
				        (pointerdown)="startStep('minute', 1, $event)"
				        (pointerup)="endStep()"
				        (pointerleave)="endStep()"
				        (pointercancel)="endStep()"
				        (keydown.enter)="stepByKey('minute', 1, $event)"
				        (keydown.space)="stepByKey('minute', 1, $event)"
				        (keyup.enter)="endStep()"
				        (keyup.space)="endStep()">
					<mat-icon>expand_less</mat-icon>
				</button>
				<span class="xp-date-time__number">{{ minuteText() }}</span>
				<button type="button"
				        class="xp-date-time__step"
				        aria-label="Previous minute"
				        (pointerdown)="startStep('minute', -1, $event)"
				        (pointerup)="endStep()"
				        (pointerleave)="endStep()"
				        (pointercancel)="endStep()"
				        (keydown.enter)="stepByKey('minute', -1, $event)"
				        (keydown.space)="stepByKey('minute', -1, $event)"
				        (keyup.enter)="endStep()"
				        (keyup.space)="endStep()">
					<mat-icon>expand_more</mat-icon>
				</button>
			</div>
			<div class="xp-date-time__column xp-date-time__column--meridiem">
				<button type="button" class="xp-date-time__step" aria-label="Switch AM and PM" (click)="toggleMeridiem()">
					<mat-icon>expand_less</mat-icon>
				</button>
				<span class="xp-date-time__number">{{ meridiem() }}</span>
				<button type="button" class="xp-date-time__step" aria-label="Switch AM and PM" (click)="toggleMeridiem()">
					<mat-icon>expand_more</mat-icon>
				</button>
			</div>
		</div>
	</div>
</ng-template>
